import { environment } from 'src/environments';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserBusinessInfo, UserPassword, UserPersonalInfo, UserProfile, NotificationPreference, NotificationPreferenceUpdate } from '../models';

const basePath = `${environment.apiBaseUrl}users`;

@Injectable({ providedIn: 'root' })
export class UserApiClient {
    private readonly _http = inject(HttpClient);

    getBusiness(): Observable<any> {
        return this._http.get<any>(`${basePath}/business`);
    }

    getUserProfile(id: string = ''): Observable<UserProfile> {
        return id
            ? this._http.get<UserProfile>(`${basePath}/profile/${id}`)
            : this._http.get<UserProfile>(`${basePath}/profile`);
    }

    updatePersonalInfo(model: UserPersonalInfo) {
        return this._http.patch(`${basePath}/personal-info`, model);
    }

    updateBusinessInfo(model: UserBusinessInfo) {
        return this._http.patch(`${basePath}/business-info`, model);
    }
    getNotificationPreferences() {
        return this._http.get<NotificationPreference[]>(`${environment.apiBaseUrl}notification-preference`);
    }
    updateNotificationPreferences(model: NotificationPreferenceUpdate[]) {
        return this._http.post(`${environment.apiBaseUrl}notification-preference/save`, model);
    }

    saveBusinessInfo(model: UserBusinessInfo) {
        return this._http.post(`${basePath}/business-info`, model);
    }

    markRegistrationComplete() {
        return this._http.patch(`${basePath}/complete-registration`, undefined);
    }

    resendCode(email: string) {
        return this._http.patch(`${basePath}/resend-code/${email}`, null, {
            headers: { 'X-WhiteLabel-Tenant': 'Neer' },
        });
    }

    changePassword(model: UserPassword): Observable<any> {
        return this._http.patch(`${basePath}/change-password`, model);
    }
}
